import {Injectable} from "@angular/core";
import {DxEncryptionStrategy} from "./dx-encryption-strategy";
import {DxLogger} from "../dx-logger.service";
import {DxAppError} from "../../domain/error/dx-app-error";

declare function escape(s:string): string;

/**
 * Cтратегия шифрования\дешифрования токенов из keycloack.
 * @publicApi
 */
@Injectable()
export class DxKeycloakEncryptionStrategy implements DxEncryptionStrategy {
  /**
   * Создает инстанс стратегии шифрования токенов в keycloak.
   * @constructor
   * @param {DxLogger} _logger - логгер.
   */
  constructor(private _logger: DxLogger) { }


  /**
   * Осуществляет свертку данных в формат токена keycloak.
   * @param {any} data - объект данных произвольного типа, подлежащий зашифровке.
   * @return {string} - токен в формате keycloak.
   * @public
   */
  public encrypt(data: any): string {
    const error = new DxAppError();
    error.message = 'Шифрование данных в формат токена keycloak не поддерживается!';
    throw error;
  }


  /**
   * Осуществляет дешифрование токена, полученного от keycloak.
   * @param {string} hash - токен.
   * @return {any} - `JSON`-объек дешифрованных данных или `null` в случае ошибки.
   * @public
   */
  public decode(hash: string): any {
    try {
      let str: string = hash;
      // данный код взят из адаптера keycloak.js
      str = str.split('.')[1];

      str = str.replace('/-/g', '+');
      str = str.replace('/_/g', '/');
      switch (str.length % 4)
      {
        case 0:
          break;
        case 2:
          str += '==';
          break;
        case 3:
          str += '=';
          break;
        default:
          throw 'Invalid token';
      }

      str = (str + '===').slice(0, str.length + (str.length % 4));
      str = str.replace(/-/g, '+').replace(/_/g, '/');
      str = atob(str);
      str = escape(str);
      str = decodeURIComponent(str);
      str = JSON.parse(str);
      return str;
    } catch (e) {
      this._logger.debug('Вызов DxKeycloakEncryptionStrategy.decode(...) завершился ошибкой: ');
      this._logger.debug(e);
    }
    return null;
  }
}
